<template>
  <button class="slide-top-button" @click="$emit('onScroll')">
    <i class="material-icons md-34 color_white">arrow_upward</i>
  </button>
</template>

<script>
export default {
  name: 'ScrollTopButton',
};
</script>

<style>
  .slide-top-button {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    bottom: 120px;
    width: 48px;
    height: 48px;
    cursor: pointer;
    outline: none;
    box-sizing: border-box;
    opacity: 0.5;
    background: rgba(0, 132, 255, 0.5);
    border: 1px solid rgba(0, 132, 255, 0.5);
    transition: background, border;
    transition-duration: 0.5s, 0.5s;
  }

  .slide-top-button:hover {
    background: rgba(0, 132, 255, 1);
    border: 1px solid rgba(0, 132, 255, 1);
  }
</style>
